/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {memo, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {FaArrowUp, FaUserEdit} from 'react-icons/fa'
import {FiX} from 'react-icons/fi'
import {MdOutlineEdit, MdRefresh} from 'react-icons/md'
import {VmoButton, VmoDropdown, VmoDropdownItem, VmoDropdownMenu} from 'vmo-library'
import {generateOpenAiMessage, modifyOpenAiEmailReply} from 'actions/inbox'
import {GENERATE_OPEN_AI_MESSAGE, MODIFY_OPEN_AI_EMAIL_REPLY} from 'actions/types'
import _ from 'lodash'
import ConditionalComponent from 'components/common/ConditionalComponent'

const OPENAI_LANGUAGES = ['english', 'german', 'french', 'spanish']

const OPENAI_TONES = ['Professional', 'Friendly', 'Empathetic', 'Authoritative', 'Urgent', 'instructional']

const AiEditor = ({ConversationId, onAiGeneratedMessage, defaultAiStep = 1}) => {
  const dispatch = useDispatch()

  const [currentStep, setCurrentStep] = useState(defaultAiStep)
  const [aiText, setAiText] = useState('')

  const {successLabels = []} = useSelector(state => state.apiReducer)
  const {generatedOpenAiMessageData = {}, modifiedOpenAiMessageData = {}} = useSelector(state => state.emailInbox)

  useEffect(() => {
    if (successLabels.includes(GENERATE_OPEN_AI_MESSAGE)) {
      onAiGeneratedMessage(generatedOpenAiMessageData?.content?.replaceAll('\n', '<br/>'))
    }
    if (successLabels.includes(MODIFY_OPEN_AI_EMAIL_REPLY)) {
      onAiGeneratedMessage(modifiedOpenAiMessageData?.content?.replaceAll('\n', '<br/>'))
    }
  }, [successLabels, generatedOpenAiMessageData, modifiedOpenAiMessageData, onAiGeneratedMessage])

  const handleSteps = action => {
    if (action === 'next') {
      setCurrentStep(currentStep + 1)
    } else if (action === 'prev') {
      setCurrentStep(currentStep - 1)
    }
  }

  const handleGenerateMessageClick = () => {
    const data = {id: ConversationId, newQuestion: aiText}
    dispatch(generateOpenAiMessage(data))
  }

  const handleModifyEmailReplyClick = (type, options = {}) => {
    const {language = '', toneType = ''} = options
    const data = {email: generatedOpenAiMessageData?.content?.replaceAll('<br/>', '\n'), type}
    if (type === 'translate') {
      data.language = language
    } else if (type === 'tone') {
      data.toneType = toneType
    }
    dispatch(modifyOpenAiEmailReply(data))
  }

  return (
    <div className="ai-editor">
      <ConditionalComponent
        conditions={[
          {
            condition: currentStep === 1,
            component: () => (
              <div className="ai-tab-icon" onClick={() => handleSteps('next')}>
                <FaUserEdit />
              </div>
            ),
          },
          {
            condition: currentStep === 2,
            component: () => (
              <div className="flex flex-justify-start flex-items-center">
                <div className="ai-tab-filter">
                  <div className="left" onClick={() => handleSteps('next')}>
                    <div className="left-icon">
                      <MdOutlineEdit />
                    </div>
                    <div style={{color: 'rgb(152, 162, 179)'}}>Input details here to refine</div>
                  </div>
                  <div className="right">
                    <VmoButton className="rephrase-btn" size="tiny" onClick={handleGenerateMessageClick}>
                      <MdRefresh /> Rephrase
                    </VmoButton>
                    <VmoDropdown button text="Refine" upward>
                      <VmoDropdownMenu style={{width: '148px'}}>
                        <VmoDropdownItem onClick={() => handleModifyEmailReplyClick('shorten')}>
                          Shorten
                        </VmoDropdownItem>
                        <VmoDropdownItem onClick={() => handleModifyEmailReplyClick('elaborate')}>
                          Elaborate
                        </VmoDropdownItem>
                        <VmoDropdownItem>
                          <VmoDropdown text="Translate" pointing="left">
                            <VmoDropdownMenu>
                              {OPENAI_LANGUAGES.map(language => (
                                <VmoDropdownItem
                                  key={language}
                                  onClick={() => handleModifyEmailReplyClick('translate', {language})}
                                >
                                  {_.startCase(language)}
                                </VmoDropdownItem>
                              ))}
                            </VmoDropdownMenu>
                          </VmoDropdown>
                        </VmoDropdownItem>
                        <VmoDropdownItem>
                          <VmoDropdown text="Change Tone" pointing="left">
                            <VmoDropdownMenu>
                              {OPENAI_TONES.map(toneType => (
                                <VmoDropdownItem
                                  key={toneType}
                                  onClick={() => handleModifyEmailReplyClick('tone', {toneType})}
                                >
                                  {_.startCase(toneType)}
                                </VmoDropdownItem>
                              ))}
                            </VmoDropdownMenu>
                          </VmoDropdown>
                        </VmoDropdownItem>
                      </VmoDropdownMenu>
                    </VmoDropdown>
                  </div>
                </div>
                <FiX className="close-icon" onClick={() => handleSteps('prev')} />
              </div>
            ),
          },
          {
            condition: currentStep === 3,
            component: () => (
              <div className="flex flex-justify-start flex-items-center">
                <div className="ai-tab-input">
                  <div className="input-icon">
                    <MdOutlineEdit style={{fontSize: '16px'}} />
                  </div>
                  <input
                    type="text"
                    placeholder="To customize your reply, input details here"
                    value={aiText}
                    onChange={e => setAiText(e.target.value)}
                    onKeyPress={e => {
                      if (e.key === 'Enter') {
                        handleGenerateMessageClick(e)
                      }
                    }}
                  />
                  <VmoButton size="mini" type="button" className="icon" onClick={handleGenerateMessageClick}>
                    <FaArrowUp />
                  </VmoButton>
                </div>
                <FiX className="close-icon" onClick={() => handleSteps('prev')} />
              </div>
            ),
          },
        ]}
      />
    </div>
  )
}

export default memo(AiEditor)
